import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import { filterSortIntentTags } from "../../../../utils/utils";
import Label from "../parts/Label";

const styles = () => ({
  root: {
    flex: 1,
    overflow: "hidden",
    height: "65px",
    marginLeft: "10px",
  },
  labelsContainer: {
    display: "flex",
    alignItems: "center",
  },
  tagsContainer: {
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap",
    overflow: "hidden",
    maxHeight: "45px",
  },
  tag: {
    marginRight: "2px",
    padding: "4px",
  },
  ellipsis: {
    marginLeft: "4px",
    color: "#71737B",
    fontSize: "12px",
  },
});

const IntentKeywords = ({ classes, item, filterIntentKeywords }) => {
  const tags = filterSortIntentTags(item, filterIntentKeywords);
  if (tags.length === 0) {
    return <div className={classes.root} />;
  }

  return (
    <div className={classes.root}>
      <div className={classes.labelsContainer}>
        <Label
          labelText="投資意欲あり"
          toolTipText="ラベルのキーワードに投資意欲があります"
          labelBgColor="#FD7E00"
        />
        {Boolean(item.is_recent_web_tool_activity) && (
          <Label
            labelText="直近導入ウェブツールあり"
            toolTipText="1ヶ月以内に導入したウェブツールがあります"
            labelBgColor="#FFC62B"
          />
        )}
      </div>
      <div className={classes.tagsContainer}>
        {tags.map((tag, index) => (
          <div key={index} className={classes.tag}>
            <Label
              labelText={tag}
              labelColor="#181819"
              labelBgColor="rgba(26, 101, 255, .05)"
              fontWeight="normal"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

IntentKeywords.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  filterIntentKeywords: PropTypes.array,
};

export default withStyles(styles)(IntentKeywords);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/Spreadsheet/cols/IntentKeywords.jsx